<app-avatar-preview class="avatar" [profileType]="profileType" [url]="avatarUrl"></app-avatar-preview>

<div class="content">
  <div class="header">
    <h2>
      {{ name }}
    </h2>
    <h3 *ngIf="tagText && tagVariant === 'success'" class="tag tag-success">{{ tagText }}</h3>
    <app-patient-status-badge
      *ngIf="tagText && tagVariant === 'prisoner'"
      [variant]="'prisoner'"
      [label]="tagText"
    ></app-patient-status-badge>
    <app-patient-status-badge
      *ngIf="tagText && tagVariant === 'violence'"
      [variant]="'violence'"
      [label]="tagText"
    ></app-patient-status-badge>
  </div>

  <ul class="badges">
    <li *ngFor="let detail of summaryInfoList" class="text-color-muted">
      {{ detail }}
    </li>
  </ul>
  <span class="text-color-muted cpf" *ngIf="cpfNumber">
    {{ cpfNumber }}
    <button libButton appearance="grey-outline" (click)="copyCpfNumber()">
      {{ "actions.copy" | translate }}
    </button>
  </span>
</div>
